module.exports = __webpack_public_path__ + "static/media/image_25.922363c4.png";